import icons from './icons'
import messages from './messages'

export default {
  icons,
  messages,
}
